import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { EField } from "./schema.kycVerification.types";

export const submitActionCreator =
  (contactId: number, asBroker = false, bankAccountId?: number) =>
  (formData: any) =>
    contactActions.kycContact.actions.start({
      contactId,
      bankAccountId,
      contact: {
        dateOfBirth: formData[EField.DateOfBirth],
        nationality: formData[EField.Nationality],
        ...formData[EField.Address],
        countryId: formData[EField.Address].country,
      },
      idCardFront: formData[EField.IdCardFront][0],
      idCardBack: formData[EField.IdCardBack][0],
      asBroker,
      onSuccess: () => {
        showAlert({
          type: "success",
          message: getLocalizedText(
            "form.kyc_receiver_as_broker.success.title",
          ),
        });
      },
    });
